import React from 'react';

const WiseWords = () => (
    <div className="wisewords">
        <h1>Bilder steuern Emotionen</h1>
        <p>Maltherapie hilft dem Körper sich zu reorganisieren.</p>
    </div>
)

export default WiseWords;